import * as React from 'react';

class YoutubeCallback extends React.Component {
  getToken = () => {
    const query = new URLSearchParams(window.location.search);
    const oauthCode = query.get('code');
    const youtubeAuth = {
      oauthCode,
    };
    window.localStorage.setItem('youtubeAuth', JSON.stringify(youtubeAuth));
    window.close();
  };

  componentDidMount() {
    this.getToken();
  }

  render() {
    return <div className="margin-top-lg">Redirecting...</div>;
  }
}

export default YoutubeCallback;
